import { Component, OnInit } from '@angular/core';
import { AccountService } from 'projects/authentication/_services/account.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalService } from 'src/app/_core/global.service';
import { LangService } from 'src/app/_core/_services/lang.service';

declare let $: any;

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.scss']
})
export class FavoritesComponent implements OnInit {

  public favourites$: any = { 0: null, 1: null };
  public selectCategory: number = 0;

  public favSlideConfig: any;

  constructor(
    private accountSvc: AccountService,
    public global: GlobalService,
    private langSvc: LangService
  ) {
    this.loadFavourites(this.selectCategory);

    this.langSvc.lang.subscribe(l => {
      this.favSlideConfig = {
        slidesToScroll: 1,
        slidesToShow: 1,
        infinite: false,
        autoplay: false,
        arrows: false,
        dots: false,
        adaptiveHeight: true,
        rtl: !!(l == 'ar')
      }
    });
  }

  ngOnInit(): void { }

  private _subs = new Subject();
  ngOnDestroy() {
    this._subs.next();
    this._subs.complete();
  }

  public loadCatContent(id) {
    this.selectCategory = id;
    $('.favouritesBox').slick('slickGoTo', id);
  }

  public catSwipe(e) {
    this.selectCategory = e.currentSlide;
    this.loadFavourites(this.selectCategory);
  }

  private loadFavourites(id, forceReload: boolean = false) {
    let cats = ['GAMES', 'OTHERS'];
    (!this.favourites$[id] || forceReload) && this.accountSvc.getFavourites({ contentType: 'VOUCHER', contentCategory: cats[id] }).pipe(takeUntil(this._subs)).subscribe(favour => {
      this.favourites$[id] = favour?.favourites || [];
      for (let f in this.favourites$[id]) { this.favourites$[id][f].cmsProps = this.global.entitysToPlain([this.favourites$[id][f].sourceObj])[0] }
      !!this.favourites$[id]?.length && setTimeout(() => { $('.favouritesBox').slick('refresh') }, 0);
      // console.debug(this.favourites$[id]);
    }, () => { this.favourites$[id] = [] });
  }

  public doDislike(voucherId) {
    this.accountSvc.removeFavourites({ favourites: [{ id: voucherId }] }).pipe(takeUntil(this._subs)).subscribe(removed => {
      removed?.responseCode == 'SUCCESS' && this.loadFavourites(this.selectCategory, true);
    }, noRemoved => { console.debug(noRemoved) });
  }

}
